import type { ComponentProps } from "react";
import MarkMono from "@/assets/brand/mark/caseblink-mark-mono.svg?react";
import { cn } from "@/lib/utils";

type Props = Omit<ComponentProps<"svg">, "children"> & {
  /**
   * `mono` renders the mark in `currentColor` so it follows the surrounding
   * text colour (dark buttons, tinted surfaces). Default is brand blue.
   */
  mono?: boolean;
  /** Accessible name; omit for a purely decorative mark. */
  title?: string;
};

/** The square CaseBlink mark. Size it with `className` (e.g. `size-8`). */
export function BrandMark({ mono = false, title, className, ...rest }: Props) {
  return (
    <MarkMono
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
      aria-label={title}
      className={cn(
        "shrink-0",
        mono ? "text-current" : "text-brand-blue",
        className
      )}
      {...rest}
    />
  );
}
